import { apiGet } from '@/services/api/apiClient';

export interface User {
  _id: string;
  name: string;
  empId: string;
  email: string;
  mobile: string;
}

export interface Company {
  _id: string;
  name: string;
}

export interface PurchaseOrder {
  _id: string;
  poNumber: string;
}

export interface Material {
  _id: string;
  materialName: string;
  materialType: string;
}

export interface QuantityData {
  initialCount: number;
  initialKg: number;
  quantityCount: number;
  quantityKg: number;
}

export interface ActivityLog {
  _id: string;
  materialId?: Material;
  materialName?: string;
  initialCount?: number;
  initialKg?: number;
  quantityCount?: number;
  quantityKg?: number;
  type: 'created' | 'updated' | 'workprocess' | 'deleted';
  level?: number;
  levelName?: string;
  poNumber?: string;
  poId?: PurchaseOrder;
  documentNumber?: string;
  jobType?: 'jobwork' | 'purchase';
  startDateTime?: string;
  companyId?: Company;
  createdBy?: User;
  updatedBy?: User;
  previous?: QuantityData;
  changes?: {
    quantityCount?: number;
    quantityKg?: number;
  };
  remarks?: string;
  createdAt: string;
  updatedAt: string;
  __v?: number;
}

export interface ActivityLogListParams {
  page?: number;
  limit?: number;
  materialId?: string;
  type?: 'created' | 'updated' | 'workprocess' | 'deleted';
  poNumber?: string;
  documentNumber?: string;
  jobType?: 'jobwork' | 'purchase';
  startDate?: string;
  endDate?: string;
  companyId?: string;
  createdBy?: string;
  level?: number;
}

export interface ActivityLogListResponse {
  success: boolean;
  data: {
    docs: ActivityLog[];
    totalDocs: number;
    limit: number;
    totalPages: number;
    page: number;
    pagingCounter: number;
    hasPrevPage: boolean;
    hasNextPage: boolean;
    prevPage: number | null;
    nextPage: number | null;
  };
}

class ActivityLogService {
  private baseUrl = '/activity-logs';

  async getActivityLogs(params: ActivityLogListParams = {}): Promise<ActivityLogListResponse> {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.materialId) queryParams.append('materialId', params.materialId);
    if (params.type) queryParams.append('type', params.type);
    if (params.poNumber) queryParams.append('poNumber', params.poNumber);
    if (params.documentNumber) queryParams.append('documentNumber', params.documentNumber);
    if (params.jobType) queryParams.append('jobType', params.jobType);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.companyId) queryParams.append('companyId', params.companyId);
    if (params.createdBy) queryParams.append('createdBy', params.createdBy);
    if (params.level !== undefined) queryParams.append('level', params.level.toString());

    const url = `${this.baseUrl}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    return apiGet<ActivityLogListResponse>(url);
  }
}

export const activityLogService = new ActivityLogService();
